import { ApiResponse } from '@mbp/core';
import { map } from 'rxjs/operators';
import { isApiResponse } from '../utilities';

export function getApiResponseData<T>() {
  return map((response: ApiResponse<T>) => {
    return isApiResponse(response) ? response?.data : response;
  });
}
